import dayjs from "dayjs";
import type { EHRSyncRun } from "../../types/index.type";

// The app says "your EHR" everywhere a clinician can see it (PatientSyncNotice,
// onboarding); the vendor name stays in logs and admin tooling.
export const SYNC_TOOLTIP = "Sync today's schedule from your EHR";
export const SYNC_HINT = "New: pull today's schedule from your EHR any time.";
// Short enough to fit the strip in a 300px sidebar without truncating.
export const SYNC_RUNNING = "Syncing today's schedule… under a minute";
export const SYNC_UP_TO_DATE = "Already up to date";

export const FAILURE_COPY = {
  busy: "Another sync for your clinic is already running. Try again in a minute.",
  error: "Couldn't reach your EHR. Try again shortly.",
  refused: "Patient sync isn't enabled for your clinic.",
} as const;

export const resultLine = (run: EHRSyncRun | null): string => {
  if (!run || (!run.created && !run.updated)) return SYNC_UP_TO_DATE;
  const parts: string[] = [];
  if (run.created) parts.push(`${run.created} added`);
  if (run.updated) parts.push(`${run.updated} updated`);
  return `${parts.join(", ")} from your EHR`;
};

export const lastSyncedLabel = (lastSyncedAt: number | null): string | null =>
  lastSyncedAt ? `Last synced ${dayjs(lastSyncedAt).format("h:mm A")}` : null;

// Throttle copy stays coarse on purpose: nobody needs second precision on a wait
// they cannot shorten, and a ticking counter would be the busiest thing in the sidebar.
export const cooldownLabel = (seconds: number): string =>
  seconds < 60 ? "under a minute" : `about ${Math.ceil(seconds / 60)} min`;
